import { render, staticRenderFns } from "./BookCourseRuleAlert.vue?vue&type=template&id=f0efe19c&scoped=true"
import script from "./BookCourseRuleAlert.vue?vue&type=script&lang=js"
export * from "./BookCourseRuleAlert.vue?vue&type=script&lang=js"
import style0 from "./BookCourseRuleAlert.vue?vue&type=style&index=0&id=f0efe19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0efe19c",
  null
  
)

export default component.exports